angular.module("core")
.filter("substring", [function($filter) {
    return function(val, from, count) {
        return (val) ? val.substr(from, count) : val;
    };
}])

.component("barcode", {
    templateUrl: require("./barcode.component.html"),
    bindings: {
        code: "=",
        format: "=",
        isShort: "<?"
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/barcode/barcode.component.js
// module id = 541
// module chunks = 0